export default "__VITE_ASSET__ef144dc4__"